"use client";

import { Command } from "cmdk";

import Content from "./Content";
import Empty from "./Empty";
import Group from "./Group";
import Input from "./Input";
import Item from "./Item";
import List from "./List";
import Root from "./Root";
import Trigger from "./Trigger";

export const Combobox = {
  Root,
  Trigger,
  Content,
  Empty,
  Group,
  Item,
  Input,
  List,
  Loading: Command.Loading,
};

export { type ComboboxContentProps } from "./Content";
export { type ComboboxEmptyProps } from "./Empty";
export { type ComboboxGroupProps } from "./Group";
export { type ComboboxInputProps } from "./Input";
export { type ComboboxItemProps } from "./Item";
export { type ComboboxRootProps } from "./Root";
export { type ComboboxTriggerProps } from "./Trigger";
